<template>
  <div class="wsc_loader--inline" v-if="value">
    <div class="loader"></div>
    <span class="loader-label">{{ $t('general.loading') }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        default: true
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/ui/loading.vue